import { useInstallation, useTransactionsQuery } from 'commons/hooks';

export const useHomeMexico = () => {
  const { data: installationData, isLoading: isLoadingInstallation } =
    useInstallation();
  const { hasTransactions, isLoading: isLoadingTransactions } =
    useTransactionsQuery({
      page: 1,
    });

  const isLoading = isLoadingInstallation || isLoadingTransactions;
  const isInstallationComplete = installationData?.status === 'COMPLETED';
  const shouldRedirectLanding = !isInstallationComplete && !hasTransactions;

  return {
    isLoading,
    shouldRedirectLanding,
  };
};
